module.exports = __webpack_public_path__ + "static/media/BTOVyMMrcpspRAmGJLCF.72bbcb87.bin";